// @ts-check
import axios from 'axios';
import config from '../constants/config';

const productsAxios = axios.create();
const productsService = {};

/**
 * Get all products list
 * Dates should be ISO strings
 * @param {import('../../../types/common').PaginationOptions} params
 * @returns
 */
productsService.getProductsList = (params) => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const token = user?.token || '';
  const url = `${config.BASEURL}v2/products/`;
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  return productsAxios.get(url, { headers, params });
};

/**
 * Update product status
 * @param {import('../../../types/common').ObjectIdType} productId
 * @param {boolean} newStatus
 * @returns
 */
productsService.updateProductStatus = (productId, newStatus) => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const token = user?.token || '';
  const url = `${config.BASEURL}v2/products/${productId}/status`;
  const headers = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };

  const data = {
    status: newStatus,
  };

  return productsAxios.patch(url, data, { headers });
};

export default productsService;
